var map = {
	"./Container": 30,
	"./Container/": 30,
	"./Container/index": 30,
	"./Container/index.js": 30,
	"./Modal": 45,
	"./Modal/": 45,
	"./Modal/index": 45,
	"./Modal/index.js": 45,
	"./Slack": 76,
	"./Slack/": 76,
	"./Slack/App": 46,
	"./Slack/App/": 46,
	"./Slack/App/index": 46,
	"./Slack/App/index.js": 46,
	"./Slack/Channel": 49,
	"./Slack/Channel/": 49,
	"./Slack/Channel/index": 49,
	"./Slack/Channel/index.js": 49,
	"./Slack/ChannelLink": 36,
	"./Slack/ChannelLink/": 36,
	"./Slack/ChannelLink/index": 36,
	"./Slack/ChannelLink/index.js": 36,
	"./Slack/ChannelPage": 26,
	"./Slack/ChannelPage/": 26,
	"./Slack/ChannelPage/index": 26,
	"./Slack/ChannelPage/index.js": 26,
	"./Slack/Project": 50,
	"./Slack/Project/": 50,
	"./Slack/Project/index": 50,
	"./Slack/Project/index.js": 50,
	"./Slack/Routers/ChannelRouter": 51,
	"./Slack/Routers/ChannelRouter/": 51,
	"./Slack/Routers/ChannelRouter/index": 51,
	"./Slack/Routers/ChannelRouter/index.js": 51,
	"./Slack/Sidebars/Channels": 54,
	"./Slack/Sidebars/Channels/": 54,
	"./Slack/Sidebars/Channels/index": 54,
	"./Slack/Sidebars/Channels/index.js": 54,
	"./Slack/Sidebars/Sidebar": 31,
	"./Slack/Sidebars/Sidebar/": 31,
	"./Slack/Sidebars/Sidebar/index": 31,
	"./Slack/Sidebars/Sidebar/index.js": 31,
	"./Slack/Sidebars/Workspaces": 53,
	"./Slack/Sidebars/Workspaces/": 53,
	"./Slack/Sidebars/Workspaces/index": 53,
	"./Slack/Sidebars/Workspaces/index.js": 53,
	"./Slack/Taskbar": 47,
	"./Slack/Taskbar/": 47,
	"./Slack/Taskbar/index": 47,
	"./Slack/Taskbar/index.js": 47,
	"./Slack/Workspace": 48,
	"./Slack/Workspace/": 48,
	"./Slack/Workspace/index": 48,
	"./Slack/Workspace/index.js": 48,
	"./Slack/index": 76,
	"./Slack/index.js": 76,
	"./Windows/Datetime": 43,
	"./Windows/Datetime/": 43,
	"./Windows/Datetime/index": 43,
	"./Windows/Datetime/index.js": 43,
	"./Windows/Hero": 40,
	"./Windows/Hero/": 40,
	"./Windows/Hero/index": 40,
	"./Windows/Hero/index.js": 40,
	"./Windows/Pin": 44,
	"./Windows/Pin/": 44,
	"./Windows/Pin/index": 44,
	"./Windows/Pin/index.js": 44,
	"./Windows/Start": 41,
	"./Windows/Start/": 41,
	"./Windows/Start/index": 41,
	"./Windows/Start/index.js": 41,
	"./Windows/Taskbar": 52,
	"./Windows/Taskbar/": 52,
	"./Windows/Taskbar/index": 52,
	"./Windows/Taskbar/index.js": 52,
	"./Windows/WinMenu": 42,
	"./Windows/WinMenu/": 42,
	"./Windows/WinMenu/index": 42,
	"./Windows/WinMenu/index.js": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 474;